import React from 'react';
import { t, props } from 'tcomb-react';

@props({
  isWelcome: t.maybe(t.Bool),
  locale: t.Obj,
  sponsor: t.maybe(t.Obj),
  options: t.maybe(t.Obj)
})

export default class Sponsor extends React.Component {

  hasSponsor() {
    return !!(this.props.sponsor);
  }

  useWelcomeSponsor() {
    return !!(this.props.options.isWelcome);
  }

  showTutorial() {
    return !!(this.props.options.showTutorial);
  }

  getDefaultImages () {
    return {
      logo: <img className='large-100' src="https://static.madai.com/pub/default_images_sponsor_madai/logo_madai_new.jpeg" />,
      cover: <img  className='large-100 large-pull-left' src="https://static.madai.com/pub/default_images_sponsor_madai/cover_image_new.jpg" />,
      tutorial: null //(this.showTutorial()) ? <img className='large-100' src="https://static.madai.com/pub/default_images_sponsor_madai/tutorial_red.jpg" /> : null
    };
  }

  getLogo()  {
    if (this.useWelcomeSponsor()){
      return this.props.sponsor.welcome_logo || this.props.sponsor.logo;
    }
    else {
      return this.props.sponsor.logo;
    }
  }

  getCover()  {
    if (this.useWelcomeSponsor()){
      return this.props.sponsor.welcome_image || this.props.sponsor.image;
    }
    else {
      return this.props.sponsor.image;
    }
  }

  getTutorialImage()  {
    if (!this.showTutorial()) {
      return null;
    }
    const src = this.getTutorialSrc();
    if (t.Nil.is(src)) {
      return null;
    }
    return (<img className='large-100' src={src} />);
  }

  getTutorialSrc()  {
    if (this.useWelcomeSponsor()){
      return this.props.sponsor.welcome_tutorial || this.props.sponsor.tutorial;
    }
    else {
      return this.props.sponsor.tutorial;
    }
  }

  getImages () {
   if ( !this.hasSponsor()) {
      return this.getDefaultImages();
    }
    return {
      logo: <img className='large-100' src={this.getLogo()} />,
      cover: <img  className='large-100 large-pull-left' src={this.getCover()} />,
      tutorial: this.getTutorialImage()
    };
  }

  render() {
    const images = this.getImages();
    return (
      <div id="sponsor">
        <div className="cols">
          <div className='large-100 small-hide'>
            <div className='large-pull-left logo'>
              {images.logo}
            </div>
            <div className='large-pull-left cover'>
              {images.cover}
            </div>
          </div>
          <div className='tutorial small-hide'>
            {images.tutorial}
          </div>
        </div>
      </div>
    );
  };
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/Sponsor.js
 **/